export const TAB_PATHS = {
    "1099_FORMS": "1099-forms",
    STATE_PAYROLL_FORMS: "statepayrollforms"
}

export const FORM_STATUS = {
    APPROVED: "Approved",
    PENDING: "Pending",
    REJECTED: "Rejected",
    RESUBMITTED: "ReSubmitted",
}

export const REIVEW_APPROVE_FORMS_DATA = [
    {
        "State": "AL",
        "FormId": 3553488,
        "TINType": "EIN",
        "EncryptedPayerId": "i%2bhLmNJrXc4%3d",
        "Name": "Recipient001",
        "TIN": "785646513",
        "TaxYear": "2022",
        "AmountCode": "Rents ",
        "Date": "8/10/2023",
        "Amount": "$   854.00",
        "IsSelect": false,
        "IsEmailRecipient": false,
        "IsState": false,
        "IsUSPSMail": false,
        "IsTinMatch": false,
        "ScheduleDropDown": "08/10/23",
        "IsTinCheck": false,
        "RecipientEmail": "No email address",
        "IsBox7Filled": false,
        "Status": "Pending",
        "StatutoryEmployee": false,
        "RetirementPlan": false,
        "ThirdPartySick": false,
        "IsImportW2": false,
        "PayerId": 0,
        "ClientRecipientId": "NA",
        "MemberEmail": "raja@yopmail.com"
    }
];

export const REVIEW_APPROVE_FORMS_LOADING_STATES = {
    DOWNLOAD_MULTIPLE_PDF_LOADING: "DOWNLOAD_MULTIPLE_PDF_LOADING",
    DOWNLOAD_MULTIPLE_PDF_READY: "DOWNLOAD_MULTIPLE_PDF_READY",
    REVIEW_APPROVE_PAGE_LOADING: "REVIEW_APPROVE_PAGE_LOADING",
    REVIEW_APPROVE_PAGE_READY: "REVIEW_APPROVE_PAGE_READY",
    REJECT_FORM_LOADING: "REJECT_FORM_LOADING",
    REJECT_FORM_READY: "REJECT_FORM_READY",
}

export const REVIEW_AND_APPROVE_FORMS_LOADING_STATES = {
    FETCHING_STATUS_LIST_LOADING: "FETCHING_STATUS_LIST_LOADING",
    FETCHING_STATUS_LIST_READY: "FETCHING_STATUS_LIST_READY",
    FETCHING_STATES_LIST_LOADING: "FETCHING_STATES_LIST_LOADING",
    FETCHING_STATES_LIST_READY: "FETCHING_STATES_LIST_READY",
    FETCHING_FORMS_LIST_LOADING: "FETCHING_FORMS_LIST_LOADING",
    FETCHING_FORMS_LIST_READY: "FETCHING_FORMS_LIST_READy",
    FETCHING_PAYERS_LIST_LOADING: "FETCHING_PAYERS_LIST_LOADING",
    FETCHING_PAYERS_LIST_READY: "FETCHING_PAYERS_LIST_READY",
    FETCHING_GRID_RECORDS_LOADING: "FETCHING_GRID_RECORDS_LOADING",
    FETCHING_GRID_RECORDS_READY: "FETCHING_GRID_RECORDS_READY",
    FETCHING_VIEW_PDF_LIST_LOADING: "FETCHING_VIEW_PDF_LIST_LOADING",
    FETCHING_VIEW_PDF_LIST_READY: "FETCHING_VIEW_PDF_LIST_READY",
    APPROVE_POPUP_LOADING: "APPROVE_POPUP_LOADING",
    APPROVE_POPUP_READY: "APPROVE_POPUP_READY",
}

export const REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP = {
    [REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_LOADING]: "",
    [REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_LOADING]: "",
    [REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]: "",
    [REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]: "",
    [REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]: "",
    [REVIEW_APPROVE_FORMS_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING]: "",
    [REVIEW_APPROVE_FORMS_LOADING_STATES.REVIEW_APPROVE_PAGE_LOADING]: "",
    [REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_LOADING]: "",
    [REVIEW_APPROVE_FORMS_LOADING_STATES.APPROVE_POPUP_LOADING]: "",
}